module.exports = __webpack_public_path__ + "static/img/78118A_3_R_20190625_LC.81186f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/78118A_3_R_20190625_LC.png
// module id = nK2S
// module chunks = 0